<template>
  <div style="display: flex;align-items: center;">
    <el-select
      v-model="customer"
      filterable
      remote
      reserve-keyword
      placeholder="请输入关键词"
      clearable
      :multiple="multiple"
      :remote-method="ownerRemoteMethod"
      :loading="ownerLoading"
      @change="handleChange"
    >
      <el-option
        v-for="item in ownerRemoteList"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      />
    </el-select>
  </div>
</template>

<script>
import { customerSearch } from '@/api/v3/assets/householder'

export default {
  components: {
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [Array, String],
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      customer: undefined,
      ownerRemoteList: [],
      ownerLoading: false,
      selectedOptions: []
    }
  },
  watch: {
    value(newValue) {
      this.customer = newValue
    }
  },
  mounted() {
    this.customer = this.value
  },
  methods: {
    ownerRemoteMethod(query) {
      this.ownerLoading = true
      customerSearch({
        keyword: query
      })
        .then((response) => {
          this.ownerRemoteList = response.data
          this.ownerLoading = false
        })
    },
    handleAddOwner() {
      this.$refs.addOwnerRef.open({ isUse: true })
    },
    // 新增客户回显
    addCustomerSuccess(result) {
      this.ownerRemoteList = [result]
      if (this.multiple) {
        this.customer ? this.customer.push(result.id) : this.customer = [result.id]
      } else {
        this.customer = result.id
      }
      this.handleChange(this.customer)
    },
    handleChange(value) {
      this.$emit('change', this.customer)
      if (value) {
        if (this.multiple) {
          const options = value.map(item => {
            const option = this.selectedOptions.find(i => i.id === item)
            const newOption = this.ownerRemoteList.find(i => i.id === item)
            if (option) return option
            if (newOption) return newOption
          })
          this.selectedOptions = options
        } else {
          this.selectedOptions = this.ownerRemoteList.find(i => i.id === value)
        }
        this.$emit('select', this.selectedOptions)
      } else {
        this.$emit('select', undefined)
      }
    }
  }

}
</script>

<style lang="scss" scoped>

</style>
